import { render, staticRenderFns } from "./AssetFolderFieldtype.vue?vue&type=template&id=6a4d4a69&"
import script from "./AssetFolderFieldtype.vue?vue&type=script&lang=js&"
export * from "./AssetFolderFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports